import { not } from 'ramda';
import { useCallback, useRef, useState } from 'react';

export const useBoolean = (initial: boolean = false) => {
  const [value, set] = useState<boolean>(initial);

  return {
    value,
    set,
    toggle: useCallback(() => set(not), []),
    setTrue: useCallback(() => set(true), []),
    setFalse: useCallback(() => set(false), []),
  };
};

export const useBooleanRef = (initial: boolean = false) => {
  const valueRef = useRef<boolean>(initial);

  const get = useCallback(() => valueRef.current, []);
  const set = useCallback((value) => (valueRef.current = value), []);

  return {
    get,
    set,
    toggle: useCallback(() => set(not(get())), []),
    setTrue: useCallback(() => set(true), []),
    setFalse: useCallback(() => set(false), []),
  };
};
